import { START_LOCATION } from 'vue-router';
import { getStore } from '@/app/shared/utils/router-guards/shared';

export const redirectWithMainEventScope = (resolveRoute) => (to, from, next) => {
    const mainEventIdScope = getStore().state.Routing.selectedMainEventId;

    if (!mainEventIdScope || to.query?.fromHeader !== 'true' || from === START_LOCATION) {
        return next();
    }

    const routeToRedirect = resolveRoute(mainEventIdScope, from, to);

    if (routeToRedirect) {
        return next(routeToRedirect);
    }

    return next();
};
